import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { scrollToSection } from '../utils/scrollUtils';
import ArrowUp from '../svgs/ArrowUp';

const ScrollToTopArrow = () => {
    const { t } = useTranslation();
    return (
        <Link to="/" onClick={scrollToSection} className="scrollToTopButton" aria-label={t('NavBar.NavItem.Home')}>
            <ArrowUp className="arrowIcon" />
        </Link>
    );
};

export default ScrollToTopArrow;
